import type { UserNotification } from '@/api/notifications'
import {
  isFeatureEnabled,
  isStudioPortalEnabled,
  type TenantFeatures,
} from '@/constants/tenant-features'

export function isNotificationCategoryEnabled(
  category: string,
  features: TenantFeatures,
): boolean {
  switch (category) {
    case 'studio':
      return isStudioPortalEnabled(features)
    case 'task':
      return isFeatureEnabled(features, 'task_center')
    case 'account':
    case 'system':
      return true
    default:
      return true
  }
}

export function filterNotificationsByFeatures(
  items: UserNotification[],
  features: TenantFeatures,
): UserNotification[] {
  return items.filter((item) => isNotificationCategoryEnabled(item.category, features))
}
